/**
 * The modal to create a new OR update a container.
 */
var VRC = VRC || {};

VRC.ContainerEditModal = (function () {
	var _template = 'edit_container';
	var _prevContainer;

	var tranformContainerPosFromMousePosition = function (containerPos) {
		return {
			x: containerPos[0] || 0,
			y: containerPos[1] || 0,
			deckID: containerPos[2] || g_current_deck.id
		};

	};

	var setPrevValues = function (serializedContainer) {
		_prevContainer = serializedContainer;
	};

	var createCtx = function (containerId) {
		var containerJson = {};
		var container;
		var isNew = true;
		if (containerId) {
			container = VRC.ContainerManager.getContainerById(containerId);
			if (container) {
				containerJson = container.toJson();

				isNew = false;
			}
		}
		else {
			container = VRC.Container();
			var posObj = tranformContainerPosFromMousePosition(g_dbl_container_pos);
			container.setPosX(posObj.x);
			container.setPosY(posObj.y);
			container.setDeckId(posObj.deckID);
			if (_prevContainer) {

				container.setOrigin(_prevContainer.origin);
				container.setDestination(_prevContainer.destination);
				container.setType(_prevContainer.type);
			}
			containerJson = container.toJson();
		}

		return {
			container: containerJson,
			containerTemplates: VRC.MasterDataService.getContainerTemplates(),
			ports: VRC.MasterDataService.getGroupedPorts(),
			containerTypes: VRC.MasterDataService.getContainerTypes(),
			dgClasses: VRC.MasterDataService.getDgClasses(),
			isNew: isNew
		}

	};

	var setDangerousTag = function(ctx, isDangerous) {
		ctx.container.properties.dangerous = isDangerous;
        $('#edit-container__dangerous').prop('checked', isDangerous);
	};

	var attachDgClass = function ($modal, ctx) {
		var $dgclass = $modal.find('#edit-container__dgClass');

		$dgclass.selectize({
			plugins: ['remove_button'],
			maxItems: 10,
            onChange: function (value) {
				if (value) {
                    setDangerousTag(ctx, true);
                }
                else {
                	setDangerousTag(ctx, false);
				}
			}
		});

		var dgClassList = $dgclass[0].selectize;
		if (ctx.container) {
			if (ctx.container.dg_class) {
				var dgClass;
				if (!_.isArray(ctx.container.dg_class)) {
					dgClass = ctx.container.dg_class.split(',');
				} else {
					dgClass = ctx.container.dg_class;
				}
				dgClassList.setValue(dgClass);
			}

		}

	};

	var attachDestination = function ($modal, ctx) {
		var $destination = $modal.find('#edit-container__destination');

		$destination.selectize(VRC.Utils.Selectize.getConfig());

		var destinationList = $destination[0].selectize;
		if (ctx.container) {
			destinationList.setValue(ctx.container.destination);
		}
	};

	var attachOrigin = function ($modal, ctx) {
		var $origin = $modal.find('#edit-container__origin');

		$origin.selectize(VRC.Utils.Selectize.getConfig());

		var originList = $origin[0].selectize;
		if (ctx.container) {
			originList.setValue(ctx.container.origin);
		}
	};

	var attchPorts = function ($modal, ctx) {
		attachDestination($modal, ctx);
		attachOrigin($modal, ctx);
	};

	var attachEvents = function (ctx) {

		var $modal = $('#modal');
		var $checkboxes = $modal.find(':checkbox');
		$checkboxes.checkboxpicker();

		attachDgClass($modal, ctx);
		attchPorts($modal, ctx);

		//TEMPLATE
		$('#edit-container__default').change(function (e) {

			var params = $(e.target).val().split(';');

			$('#tag').val(params[0]);
			$('#length').val(params[1]);
			$('#width').val(params[2]);
			if (params[3] !== undefined) {
				$('#type').val(params[3]);
			}
		});

		var $btnMultiple = $modal.find('.btn-multiple');
		var $btnConfirm = $modal.find('.btn-confirm');
		var $containerQty = $modal.find('#edit-container__qty');

		$btnMultiple.click(function (e) {
			updateBtnText(1);
			$containerQty.show();
			$btnMultiple.hide();
			$containerQty.keyup(function () {
				updateBtnText($(this).val());
			});
		});

		$modal.find('.btn-cancel').click(VRC.ModalManager.hide);

		if (ctx.isNew === true) {
			$btnConfirm.click(createContainer);
		}
		else {
			$btnConfirm.click(function (e) {
				updateContainer(e, ctx.container.id);
			});
		}

	};

	var updateBtnText = function (number) {
		var disable = false;
		var MAX_CONTAINERS = 10;
		var text = 'Create container';
		var $modal = $('#modal');
		var $btn = $modal.find('.btn-confirm');
		try {
			if (number) {
				number = parseInt(number);
				if (number <= MAX_CONTAINERS && number > 0) {
					var ending = '';
					if (number > 1) {
						ending = 's';
					}
					text = 'Create ' + number + ' container' + ending;
				}
				else {
					disable = true;
					text = 'To many containers';
				}
			}
		}
		catch (e) {
			disable = true;
			text = 'Cannot create containers';
		}
		if (disable) {
			$btn.prop('disabled', 'disabled');
		}
		else {
			$btn.prop('disabled', false);
		}
		$btn.text(text);
	};

	var serializeContainer = function ($target) {
		var $body = $target.closest('.modal-body');

		var $inputElements = $body.find(':input');
		var serializedObject = VRC.Utils.Forms.serializeObject($inputElements);

		return serializedObject;
	};

	var createContainer = function (e) {
		e.preventDefault();

		var createContainer = function (serializedObject) {
			var container = VRC.Container(serializedObject);
			VRC.ContainerManager.add(container);
			setPrevValues(serializedObject);
			VRC.ModalManager.hide();
		};

		var $target = $(e.target);
		var serializedObject = serializeContainer($target);

		var qty = $('#edit-container__qty').val();
		if (qty) {
			var multipleContainerQty = 1;

			try {
				multipleContainerQty = parseInt(qty)
			}
			catch (e) {
				console.error(e);
			}
			for (var ii = 0; ii < multipleContainerQty; ii++) {
				createContainer(serializedObject);
				try {
					serializedObject.position.x = parseFloat(serializedObject.position.x + 1) || '';
					serializedObject.position.y = parseFloat(serializedObject.position.y + 1) || '';
				}
				catch (e) {
					console.error(e);
				}
			}

		}
		else {
			createContainer(serializedObject);
		}

	};

	var updateContainer = function (e, containerId) {
		e.preventDefault();
		var $target = $(e.target);
		var serializedObject = serializeContainer($target);
		var container = VRC.ContainerManager.getContainerById(containerId);

		serializedObject.features.rotation = container.getRotation();

		container.update(serializedObject);
		VRC.ContainerManager.update(container);

		VRC.ModalManager.hide();

	};

	var show = function (containerId) {
		var ctx = createCtx(containerId);
		VRC.ModalManager.show(_template, ctx);

		attachEvents(ctx);
	};

	return {
		show: show,
		hide: function () {
			VRC.ModalManager.hide();
		},
		setPrevValues: setPrevValues
	}
})();
